import "shared/extensions/date";

import { ReactComponent as AppleStoreSvg } from "shared/assets/AppleStore.svg";
import { EventNames } from "core/monitoring/types/enums";
import { ReactComponent as GooglePlaySvg } from "shared/assets/GooglePlay.svg";
import { QRCodeSVG } from "qrcode.react";
import { UserState } from "core/state/userState";
import { externalLink } from "core/links";
import { trackBtnClicks } from "core/monitoring/Events";
import { useTranslation } from "react-i18next";
import { useTwoFactorAuthSetup } from "shared/core/hooks/useTwoFactorAuth";

export const Setup = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "accountSecurity.twoFactorAuth.setup" });
  const user = UserState.get();
  const { secret } = useTwoFactorAuthSetup();
  const issuer = process.env.REACT_APP_APP_NAME;
  const qrCodeValue = `otpauth://totp/${issuer}:${user?.email}?secret=${secret}&issuer=${issuer}`;
  const splitIntoGroupsOfFour = /[\s\S]{1,4}/g;

  const handleStoreClick = (store: "apple" | "google") => {
    if (store === "apple") {
      trackBtnClicks(EventNames.AUTHENTICATOR_ON_APPSTORE);
      process.env.REACT_APP_AUTHENTICATOR_APPSTORE_URI && externalLink(process.env.REACT_APP_AUTHENTICATOR_APPSTORE_URI);
    }
    if (store === "google") {
      trackBtnClicks(EventNames.AUTHENTICATOR_ON_PLAYSTORE);
      process.env.REACT_APP_AUTHENTICATOR_PLAYSTORE_URI && externalLink(process.env.REACT_APP_AUTHENTICATOR_PLAYSTORE_URI);
    }
  };

  return (
    <div className="space-y-6 lg:space-y-8">
      <h2>{t("title")}</h2>
      <div className="space-y-6">
        <div className="space-y-2">
          <h3>{t("qrCodeTitle")}</h3>
          <QRCodeSVG className="w-48 h-48 md:w-64 md:h-64" value={qrCodeValue} />
        </div>
        <div className="space-y-2">
          <h3>{t("manualCodeTitle")}</h3>
          <div className="px-2 py-4  md:px-8 text-center rounded-lg lg:p-8 bg-silver">
            <p className="space-x-2 md:space-x-8 text-xl font-bold">
              {secret?.match(splitIntoGroupsOfFour)?.map((str: string) => (
                <span data-testid="manualCodeSpan" key={str}>
                  {str}
                </span>
              ))}
            </p>
          </div>
        </div>
      </div>
      <div className="pt-4 space-y-8">
        <div>
          <h3>{t("NoAuthTitle")}</h3>
          <p>{t("NoAuthDescription")}</p>
        </div>
        <div className="flex justify-between gap-6">
          <AppleStoreSvg name="AppleStore" role="button" onClick={() => handleStoreClick("apple")} width={300} />
          <GooglePlaySvg role="button" name="GooglePlay" onClick={() => handleStoreClick("google")} width={300} />
        </div>
      </div>
    </div>
  );
};
